<template>
  <div class="page flex-col">
    <div class="outer flex-col">
      <header>
        <div class="nav flex-col">
          <div class="nav-menu flex-row">
            <div class="left">
                <img class="logo" src="./assets/logo.png" alt="明源云-天际"/>
                <span :class="{ 'active-item': activeTab === 'home' }" class="menu-item item2" @click="tabHandler('home')">安装使用</span>
                <span :class="{ 'active-item': activeTab === 'log' }" class="menu-item item2" @click="tabHandler('log')">更新日志</span>
            </div>
            <div class="right">
              <div class="wx-group-tip">
                <img class="wx-group-tip-img" src="./assets/wxgroup.png" alt="用户反馈群" />
                <span class="wx-group-tip-text">用户反馈群</span>
                <div class="wx-group">
                  <div class="wx-group-img">
                    <img class="pic" src="./assets/wxgroup2.png" alt="加入天际助手用户交流群" />
                  </div>
                  <span>加入天际助手用户交流群</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <HomePage v-if="activeTab === 'home'" />
      <LogPage v-else/>
    </div>
  </div>
</template>

<script>
import HomePage from './components/Home.vue'
import LogPage from './components/LogPage.vue'
import 'element-plus/dist/index.css'

export default {
  name: 'App',
  components: {
    HomePage,
    LogPage
  },
  data () {
    return {
      activeTab: 'home'
    }
  },
  methods: {
    tabHandler (type) {
      this.activeTab = type
    }
  }
}
</script>

<style lang="less" src="./styles/common.less" />
<style lang="less" src="./styles/index.less" />
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
